import { useEffect, useCallback, useRef } from 'react';
import { useBlocker, type BlockerFunction } from 'react-router-dom';

export const usePrompt = (when: boolean, message: string) => {
  // 저장·삭제 직후 이동처럼 확인 없이 보내야 하는 이동 — 상태 반영(렌더·effect)을 기다리지 않도록 ref 로 바로 읽는다
  const allowNextRef = useRef(false);

  const shouldBlock = useCallback<BlockerFunction>(
    ({ currentLocation, nextLocation }) => {
      if (allowNextRef.current) {
        allowNextRef.current = false;
        return false;
      }
      return when && currentLocation.pathname !== nextLocation.pathname;
    },
    [when],
  );

  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      const confirmed = window.confirm(message);
      if (confirmed) {
        blocker.proceed();
      } else {
        blocker.reset();
      }
    }
  }, [blocker, message]);

  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [when, message]);

  /** 바로 다음 이동 한 번은 확인 없이 보낸다 — navigate 직전에 부른다 */
  const allowNextNavigation = useCallback(() => {
    allowNextRef.current = true;
  }, []);

  return { allowNextNavigation };
};

export default usePrompt;
